import React, { useState } from 'react';
import Resizable, { type ResizeHandler } from 'react-resizable-box';
import styles from './index.module.less';

export type ResizableBoxProps = {
  direction: 'top' | 'left' | 'bottom' | 'right';
  width?: number | string;
  height?: number;
  minWidth?: number;
  maxWidth?: number;
  minHeight?: number;
  maxHeight?: number;
  disabled?: boolean;
  style?: React.CSSProperties;
  onResizeStop?: () => void;
  onResize?: ResizeHandler;
  onResizeStart?: () => void;
};

const ResizableBox: React.FC<ResizableBoxProps> = ({
  direction,
  width,
  height,
  minHeight,
  minWidth,
  maxHeight,
  maxWidth,
  children,
  style,
  disabled,
  onResizeStop,
  onResizeStart,
  onResize
}) => {
  const [isDragged, setIsDragged] = useState<boolean>(false);
  const isHorizontal = direction === 'left' || direction === 'right';
  return (
    <Resizable
      onResizeStart={() => {
        setIsDragged(true);
        if (onResizeStart) onResizeStart();
      }}
      onResize={onResize}
      onResizeStop={() => {
        setIsDragged(false);
        if (onResizeStop) onResizeStop();
      }}
      maxWidth={maxWidth}
      minWidth={minWidth}
      width={width}
      height={height}
      minHeight={minHeight}
      maxHeight={maxHeight}
      enable={{
        top: disabled !== true && direction === 'top',
        right: disabled !== true && direction === 'right',
        bottom: disabled !== true && direction === 'bottom',
        left: disabled !== true && direction === 'left',
        topRight: false,
        bottomRight: false,
        bottomLeft: false,
        topLeft: false
      }}
    >
      <div
        style={style}
        className={`${styles['resizable-box']} ${
          isDragged ? styles['resizable-box-dragged'] : ''
        } ${styles[`resizable-box-${isHorizontal ? 'horizontal' : 'vertical'}`]}`}
      >
        {children}
      </div>
    </Resizable>
  );
};

export default ResizableBox;
